export default __webpack_public_path__ + "static/media/IDEC.cd2bf262.png";